export const Logo = ({ className = "", light = false }) => {
  const c = light ? "#7ED9D2" : "#0A7189";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 64 64" className="h-8 w-8" aria-hidden="true">
        <path d="M32 8C32 8 15 28 15 40a17 17 0 0 0 34 0C49 28 32 8 32 8Z" fill="none" stroke={c} strokeWidth="3.5" />
        <path d="M20 40c4-3 8-3 12 0s8 3 12 0M22 47c3-2.4 6.6-2.4 10 0s7 2.4 10 0" fill="none" stroke={c} strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className="font-display text-2xl leading-none tracking-tight">Mareia</span>
    </span>
  );
};
